import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Box, MenuItem
} from '@mui/material';
import { putIngreso } from '../../services/apis';

export const EditarIngresoDialog = ({ open, onClose, ingreso, cargarDatos, currenApartado, conceptos = [] }) => {
    const [form, setForm] = useState({
        id_tipo_ingreso: null,
        cantidad: '',
        id_usuario: null,
        id_apartado: currenApartado || null,
        id_concepto_contabilidad: ''
    });

    useEffect(() => {
        if (ingreso) {
            setForm({
                id_tipo_ingreso: ingreso.id_tipo_ingreso || null,
                cantidad: ingreso.cantidad ?? '',
                id_usuario: ingreso.id_usuario || null,
                id_apartado: currenApartado || null,
                id_concepto_contabilidad: ingreso.id_concepto_contabilidad || ''
            });
        }
    }, [ingreso, currenApartado]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        if (ingreso?.ticket_pendiente) {
            if (!ingreso?.id_evento) return;
        } else if (!form.id_tipo_ingreso || form.cantidad === '') {
            return;
        }
        subirCambios();
    };

    const subirCambios = async () => {
        const payload = {
            id_ingreso: ingreso?.id_ingreso || null,
            id_tipo_ingreso: form.id_tipo_ingreso,
            cantidad: form.cantidad,
            id_usuario: form.id_usuario,
            id_apartado: form.id_apartado,
            id_concepto_contabilidad: form.id_concepto_contabilidad || null,
            id_evento: ingreso?.id_evento || null,
            ticket_pendiente: ingreso?.ticket_pendiente ? 1 : 0,
            es_ingreso_ticket: ingreso?.es_ingreso_ticket ? 1 : 0
        };

        try {
            const response = await putIngreso(payload);
            if (response?.success === true) {
                cargarDatos();
                onClose();
            } else {
                console.error('Error en la resposta del servidor:', response);
            }
        } catch (error) {
            console.error("Error en actualitzar l'ingrés:", error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Editar ingrés</DialogTitle>
            <DialogContent>
                <Box className="ki-form-stack">
                    <TextField
                        label="Usuari"
                        value={ingreso?.nombre_usuario || 'General'}
                        fullWidth
                        disabled
                    />
                    <TextField
                        label="Tipus d'ingrés"
                        value={ingreso?.tipo_ingreso || ''}
                        fullWidth
                        disabled
                    />
                    <TextField
                        label="Quantitat"
                        name="cantidad"
                        type="number"
                        value={form.cantidad}
                        onChange={handleChange}
                        fullWidth
                        disabled={Boolean(ingreso?.es_ingreso_ticket || ingreso?.ticket_pendiente)}
                    />
                    <TextField
                        select
                        label="Concepte predefinit"
                        name="id_concepto_contabilidad"
                        value={form.id_concepto_contabilidad || ''}
                        onChange={handleChange}
                        fullWidth
                    >
                        <MenuItem value="">No definit</MenuItem>
                        {conceptos.map((concepto) => (
                            <MenuItem key={concepto.id} value={concepto.id}>
                                {concepto.nombre}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel·lar</Button>
                <Button variant="contained" onClick={handleSubmit}>Guardar canvis</Button>
            </DialogActions>
        </Dialog>
    );
};
